import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpClient } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule as AngularCommonModule } from '@angular/common';

import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { BlockUIModule } from 'ng-block-ui';
import { BlockUIHttpModule } from 'ng-block-ui/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function blockUIHttpModuleRequestFilter(req: HttpRequest<any>): boolean {
	return Boolean(req.url.match(/noBlock/g));
}

@NgModule({
	// declarations: [

	// ],
	imports: [
		AngularCommonModule,
		BrowserModule.withServerTransition({ appId: 'serverApp' }),
		HttpClientModule,
		BrowserAnimationsModule,
		FormsModule,
		BlockUIModule.forRoot({
			delayStart: 150,
			delayStop: 500,
		}),
		BlockUIHttpModule.forRoot({
			requestFilters: [blockUIHttpModuleRequestFilter],
		}),
	],
	exports: [AngularCommonModule, BrowserModule, HttpClientModule, BrowserAnimationsModule, FormsModule, BlockUIModule, BlockUIHttpModule],
	providers: [],
})
export class CoreModule {}
